<template>
  <div :class="type" :style="{ top: `${offset}px` }">
    <div class="inner_box">
      <p>
        <slot />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-notification',
  props: {
    offset: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'error'].includes(value)
    }
  }
}
</script>
